import { WaypointActionType } from '@caresend/types';

const isSampleProcessingAction = waypointAction => waypointAction.type === WaypointActionType.SAMPLE && 'supplyInstruction' in waypointAction;
const getSampleProcessingAction = waypointAction => {
  if (!waypointAction) return;

  if (isSampleProcessingAction(waypointAction)) {
    return waypointAction;
  }
};

export { getSampleProcessingAction, isSampleProcessingAction };
